import { Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router';

import { CustomAvatar } from '@app/components/custom-avatar';
import { TableCellCustom } from '@app/components/table';
import { IIntern } from '../types';
import { RowActions } from './row-actions';
import { StatusTag, TruncatedTypography } from '@app/components';
import { EmployeeStatus, Strings } from '@app/constants';
import { PATH_DASHBOARD } from '@app/routes/paths';

interface Props {
  row: IIntern;
  selected: boolean;
  onSelectRow: VoidFunction;
}

const InternRow = (props: Props) => {
  const { row } = props;

  const navigate = useNavigate();
  const handleDetails = () => {
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    navigate(`${PATH_DASHBOARD.internDetail}/${row.firstName}`, { state: { id: row.id } });
  };
  let statusValue;
  if (row.status === Strings.status.inactive) {
    statusValue = EmployeeStatus.Inactive;
  } else {
    statusValue = EmployeeStatus.Active;
  }
  // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
  const name = `${row?.firstName} ${row?.lastName}`;

  return (
    <>
      <TableCellCustom
        flex
        onClick={handleDetails}
        style={{ cursor: 'pointer', width: '10px' }}
        align="center"
      >
        <Typography variant="body2">{row.id}</Typography>
      </TableCellCustom>
      <TableCellCustom onClick={handleDetails} style={{ cursor: 'pointer' }} width={'180px'}>
        <Stack style={{ flexDirection: 'row', alignItems: 'center', gap: '9px' }}>
          <CustomAvatar name={name} color="info" src={row?.profileImage} />
          <TruncatedTypography text={name} />
        </Stack>
      </TableCellCustom>
      <TableCellCustom onClick={handleDetails} style={{ cursor: 'pointer' }} width={'250px'}>
        <Stack sx={{ alignItems: 'center' }}>
          <Typography variant="body2">{row?.email}</Typography>
        </Stack>
      </TableCellCustom>
      <TableCellCustom
        onClick={handleDetails}
        style={{ cursor: 'pointer' }}
        align="center"
        width={'60px'}
      >
        <Typography variant="body2">{row?.phone ? row.phone : 'NA'}</Typography>
      </TableCellCustom>
      {
        <TableCellCustom flex onClick={handleDetails} style={{ cursor: 'pointer' }} align="center">
          <Typography variant="body2">
            {row?.source === 'Other'
              ? row?.other ?? 'NA'
              : row?.source === 'Reference'
              ? `Reference By ${row?.referenceBy ?? 'NA'}`
              : row?.source ?? 'NA'}
          </Typography>
        </TableCellCustom>
      }
      <TableCellCustom flex align="center" onClick={handleDetails} style={{ cursor: 'pointer' }}>
        <StatusTag status={EmployeeStatus[statusValue]} />
      </TableCellCustom>
      <TableCellCustom align="right" width={50}>
        <RowActions row={row} />
      </TableCellCustom>
    </>
  );
};

export { InternRow };
